import {useQuery} from "@tanstack/react-query";
import client from '../../utils/Client'
import { normalizePaged } from "../../utils/helpers";




// GET ALL BRANCHES
const branches = (pageNumber='1',pageSize='10') => client.get(`branch?pageNumber=${pageNumber}&pageSize=${pageSize}`);
export const useGetBranches = (pageNumber,pageSize) => useQuery(['branches'],()=> branches(pageNumber,pageSize), {select: data => data?.data?.result,refetchInterval:60_000})
export const useGetBranchesPaged = (pageNumber = 1, pageSize = 10) =>
  useQuery(
    ["branches-paged", pageNumber, pageSize],
    async () => {
      const { data } = await branches(pageNumber, pageSize);
      return normalizePaged(data?.data ?? data, { pageNumber, pageSize });
    },
    {
      keepPreviousData: true,
      refetchInterval: 60_000,
    }
  );


// GET A BRANCH
const branch = (id) => client.get(`branch/${id}`);
export const useGetBranch = (id) => useQuery(['branches',id],()=> branch(id), {select: data => data?.data?.result,refetchInterval:60_000})
